import React from "react";
import "./App.css";
import upload_video from "./videos/1-upload-video.mp4";
import analysis_video from "./videos/2-analysis-result.mp4";
import search_scene from "./videos/3-search-scene.mp4";
import insert_product from "./videos/4-insert-product.mp4";
import ads_display from "./videos/5-ads-display.mp4";
import product from "./videos/product.mp4";
import "antd/dist/antd.css";


class DemoPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tabs: [
                {tabName: "Upload Video", id: 1},
                {tabName: "Analyse Video", id: 2},
                {tabName: "Search Scene", id: 3},
                {tabName: "Insert Product", id: 4},
                {tabName: "Display Ads", id: 5},
                {tabName: "Product App", id: 6}
            ],
            currentIndex: 1,
        };
    }

    componentDidMount() {

    }

    tabChoiced = (id) => {
        this.setState({
            currentIndex: id
        });
    }

    render() {
        var _this = this;
        var isBox1Show = this.state.currentIndex === 1 ? 'block' : 'none';
        var isBox2Show = this.state.currentIndex === 2 ? 'block' : 'none';
        var isBox3Show = this.state.currentIndex === 3 ? 'block' : 'none';
        var isBox4Show = this.state.currentIndex === 4 ? 'block' : 'none';
        var isBox5Show = this.state.currentIndex === 5 ? 'block' : 'none';
        var isBox6Show = this.state.currentIndex === 6 ? 'block' : 'none';


        var tabList = this.state.tabs.map(function (res, index) {
            var tabStyle = res.id === this.state.currentIndex ? 'subCtrl active' : 'subCtrl';
            return <ul key={index} onClick={this.tabChoiced.bind(_this, res.id)} className={tabStyle}>{res.tabName}</ul>
        }.bind(_this));
        return (
            <div className="App">
                <h1 align="center" style={{marginTop: "15px", fontSize: 25}}>
                    Hysia: Serving DNN-Based Video-to-Retail Applications in Cloud
                </h1>
                <p style={{marginTop: "-10px"}}>
                    Huaizheng Zhang, Yuanming Li, Qiming Ai, Yong Luo,
                    Yonggang Wen, Yichao Jin, Nguyen Binh Duong Ta
                </p>
                <p style={{marginTop: "-8px"}}>
                    Nanyang Technological University, Indeed Inc., Singapore Management University
                </p>
                <p align="center" style={{marginTop: "15px"}}>
                    <a href="https://github.com/cap-ntu/Video-to-Online-Platform">Code</a>{" "}
                    •&nbsp;
                    <a href="https://github.com/cap-ntu/Video-to-Online-Platform">Paper</a>{" "}
                    •&nbsp;
                    <a href="https://github.com/cap-ntu/Video-to-Online-Platform">
                        Tutorial
                    </a>{" "}
                    •&nbsp;
                    <a href="https://github.com/cap-ntu/Video-to-Online-Platform">Slides</a>{" "}
                    •&nbsp;
                    <a href="https://github.com/cap-ntu/Video-to-Online-Platform">
                        Citation
                    </a>{" "}
                    •&nbsp;
                    <a href="https://github.com/cap-ntu/Video-to-Online-Platform">News</a>
                </p>

                <h1 align="left" style={{marginTop: "15px", fontSize: 25}}>
                    Abstract
                </h1>

                <div className="Abstract">
                    <p align="left" style={{wordBreak: "normal"}}>
                        Combining <ins>v</ins>ideo streaming and online <ins>r</ins>etailing (V2R) has been a growing
                        trend recently. In this paper, we provide practitioners and researchers in multimedia with a
                        cloud-based platform named Hysia for easy development and deployment of V2R applications. The
                        system consists of: 1) a back-end infrastructure providing optimized V2R related services
                        including data engine, model repository, model serving and content matching; and 2) an
                        application layer which enables rapid V2R application prototyping. Hysia addresses industry
                        and academic needs in large-scale multimedia by: 1) seamlessly integrating state-of-the-art
                        libraries including NVIDIA video SDK, Facebook faiss, and gRPC; 2) efficiently utilizing GPU
                        computation; and 3) allowing developers to bind new models easily to meet the rapidly changing
                        deep learning (DL) techniques. On top of that, we implement an orchestrator for further
                        optimizing DL model serving performance. Hysia has been released as an open source project on
                        GitHub, and attracted considerable attention. We have published Hysia to DockerHub as an
                        official image for seamless integration and deployment in current cloud environments.
                    </p>
                </div>

                <h1 align="left" style={{marginTop: "15px", fontSize: 25}}>
                    Demo
                </h1>

                <div className="listWrap">
                    {/*<img src={maskrcnn} width="75%" alt="..." />*/}
                    <div className="subNavWrap">
                        {tabList}
                    </div>
                    <div className="newsList">
                        <div style={{"display": isBox1Show}}>
                            <video src={upload_video} width="75%" controls="controls"/>
                        </div>
                        <div style={{"display": isBox2Show}}>
                            <video src={analysis_video} width="75%" controls="controls"/>
                        </div>
                        <div style={{"display": isBox3Show}}>
                            <video src={search_scene} width="75%" controls="controls"/>
                        </div>
                        <div style={{"display": isBox4Show}}>
                            <video src={insert_product} width="75%" controls="controls"/>
                        </div>
                        <div style={{"display": isBox5Show}}>
                            <video src={ads_display} width="75%" controls="controls"/>
                        </div>
                        <div style={{"display": isBox6Show}}>
                            <video src={product} width="75%" controls="controls"/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DemoPage;

